module.exports = __webpack_public_path__ + "img/application-orange.af84a7f8.svg";